<template>
    <div class="spaces container" id="million-bit-spaces">
      <h1 class="text-center">Based Spaces & Firesides</h1>
      <p class="text-center">X Spaces and Fireside chats hosted by members of the MBH community.</p>

      <div class="btn-group btn-block">
        <a href="https://calendar.google.com/calendar/embed?src=ab4b8a40f14e89db94afb2cbaf4fbef2476606632ba430555522f35c1380374a%40group.calendar.google.com&ctz=America%2FLos_Angeles" target="_blank" class="btn btn-icon btn-block btn-primary my-3">Calendar</a>
        <a href="https://t.me/based_spaces" target="_blank" class="btn btn-icon btn-block btn-primary my-3">Telegram Alerts</a>
      </div>

      <h3>Coming up {{ nextPast === 'next' ? 'next' : 'past' }} <button @click="togglePastNext" class="btn btn-link">{{ nextPast === 'next' ? 'Past' : 'Next' }}</button></h3>
      <!-- For each event (space or fireside) -->
       <div class="space-events">
       <a v-for="event in events" v-bind:key="event.url" v-bind:href="event.url" target="_blank" v-bind:class="event.type">
          <span class="event-type-badge">{{ event.type === 'fireside' ? 'Fireside' : 'X Space' }}</span>
          <h4><img v-bind:src="getAvatar(event)" /> {{ getHostName(event) }}</h4>
          <h3>{{ event.title }}</h3>
          <div>{{ formatDate(event.scheduled_start_at) }}</div>
       </a>
      </div>
    </div>
  </template>

  <script>
  const BASE_S3_BUCKET_TRX = process.env.BASE_S3_BUCKET_TRX;
  const BASE_S3_BUCKET = process.env.BASE_S3_BUCKET;
  export default {
    name: 'spaces',
    data () {
      return {
        variantNavButton: 'warning',
        events: [],
        eventsNext: [],
        eventsPast: [],
        nextPast: 'next',
        s3Base: BASE_S3_BUCKET_TRX,
        dataSrc: BASE_S3_BUCKET+'schedule.json?'+Date.now(),
        // For past, we need to combine spaces-past.json (no schedule-past yet)
        dataSrcSpacesPast: BASE_S3_BUCKET+'spaces-past.json?'+Date.now(),
      }
    },
    inject: ['updateAppRoute', 'appData', 'postToLambda'],
    created: function () {
      this.updateAppRoute('spaces');
      axios.get(this.dataSrc)
      .then((response) => {
        this.eventsNext = response.data;
        this.events = this.eventsNext;
      });
    },
    methods: {
      togglePastNext: async function() {
        if (this.nextPast === 'next') {
          await this.fetchPastEvents();
          this.events = this.eventsPast;
          this.nextPast = 'past';
        } else {
          this.events = this.eventsNext;
          this.nextPast = 'next';
        }
      },
      fetchPastEvents: async function() {
        // For now, only spaces have a past JSON file
        // TODO: Add schedule-past.json when available
        return new Promise((resolve, reject) => {
          axios.get(this.dataSrcSpacesPast)
          .then((response) => {
            // Normalize past spaces to match schedule.json format
            this.eventsPast = response.data.map(function(space) {
              return {
                type: 'space',
                title: space.title,
                url: 'https://x.com/i/spaces/' + space.id,
                scheduled_start_at: space.scheduled_start_at,
                host: {
                  name: space.creator && space.creator.name,
                  username: space.creator && space.creator.username,
                  avatar: space.creator && space.creator.profile_image_url,
                }
              };
            });
            resolve();
          });
        });
      },
      getAvatar: function(event) {
        // Handle both schedule.json format and legacy spaces format
        if (event.host && event.host.avatar) return event.host.avatar;
        if (event.host && event.host.profile_image_url) return event.host.profile_image_url;
        if (event.creator && event.creator.profile_image_url) return event.creator.profile_image_url;
        return '';
      },
      getHostName: function(event) {
        // Handle both schedule.json format and legacy spaces format
        if (event.host && event.host.name) return event.host.name;
        if (event.creator && event.creator.name) return event.creator.name;
        return (event.host && event.host.username) || '';
      },
      formatDate: function(date) {
        let d = new Date(date);
        // Format the date
        const options = {
            weekday: 'short',   // "Tue"
            month: 'short',     // "Sep"
            day: 'numeric',     // "27"
            hour: 'numeric',    // "2"
            minute: '2-digit',  // "00"
            hour12: true,       // "2:00 pm" (12-hour format)
            // timeZone: 'America/New_York', // Timezone for EST
            timeZoneName: 'short' // "EST"
        };

        const formattedDate = d.toLocaleString('en-US', options);
        return formattedDate;
      },
      clickSpace: function(space) {
        console.log('clicked space', space);
      }
    }
  }
  </script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    #million-bit-spaces {
      background: #fff !important;
      padding: 20px;
      text-align: left;
      text-decoration: none;
    }
    #million-bit-spaces .space-events a {
      text-decoration: none;
      background: #9c63fa;
      display: block;
      border-radius: 10px;
      margin: 24px 10px;
      color: white;
      padding: 10px 24px;
      border: 1px solid #9c63fa;
      position: relative;
    }
    #million-bit-spaces .space-events a.fireside {
      background: #f97316;
      border-color: #f97316;
    }
    #million-bit-spaces .space-events a:hover {
      border: 1px solid black;
      box-shadow: #9c63fa 0px 0px 10px;
    }
    #million-bit-spaces .space-events a.fireside:hover {
      box-shadow: #f97316 0px 0px 10px;
    }
    #million-bit-spaces img {
      border-radius: 50%;
      width: 24px;
      height: 24px;
    }
    #million-bit-spaces .space-events a h3 {
      padding: 10px 0;
    }
    #million-bit-spaces .event-type-badge {
      position: absolute;
      top: 10px;
      right: 10px;
      font-size: 11px;
      background: rgba(255,255,255,0.2);
      padding: 2px 8px;
      border-radius: 4px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
  </style>



// WEBPACK FOOTER //
// src/components/Spaces.vue?b9977a3a